export function keyTerms() {
    const windowWidth = this._window.innerWidth;
    const keyTermsWindows = this._document.querySelectorAll(".key-terms");

    this._window.addEventListener("load", () => {
        if(windowWidth >= 1600) {
            for(const keyTermsWindow of keyTermsWindows) {
                const parent = keyTermsWindow.parentElement.querySelector(".content");
                const firstElem = parent.children[0];
                if(firstElem.nodeName.charAt(0).toLowerCase() === "h") {
                    keyTermsWindow.style.transform = `translateY(${firstElem.offsetHeight + 24}px)`;
                }
            }
        }
    });
}


// WEBPACK FOOTER //
// ./assets/js/modules/key-terms.js